@if (assessmentState === BehavioralAssessmentStatus.Unknown) {
    @if (isThirdPartyUser) {
        <div
            class="alert alert-info alert--singleLine"
            style="margin: 30px 20px 0px"
        >
            <div class="alert-aside">
                <abstract-icon [iconType]="IconType.Info"></abstract-icon>
            </div>
            <div class="alert-main">
                <p>
                    {{ 'userProfile.restrictThirdPartyBA.tooltip' | translate }}
                </p>
            </div>
        </div>
    }
    <skip-or-launch-ba
        class="skip-or-launch-component"
        [invitationSource]="getInvitationSource()"
        [invitationQueryParam]="getInvitationQueryParam()"
        [hideSkipAssessmentText]="true"
        [globalNavContext]="globalNavContext"
        (assessmentCreated)="assessmentCreated($event)"
    ></skip-or-launch-ba>
}

@if (assessmentState === BehavioralAssessmentStatus.Pending) {
    <!-- Build the pending state component -->
    <my-profile-tooltip-pending
        class="tooltip-pending-component"
    ></my-profile-tooltip-pending>
}

@if (assessmentState === BehavioralAssessmentStatus.Completed) {
    <my-ba-profile
        [person]="self"
        [showCoverView]="showMyBACover"
        (viewProfileClicked)="myBaService.applyViewedProfileCover()"
        class="my-ba-profile"
    ></my-ba-profile>
}
